import React from 'react';
import { useSelector } from "react-redux";
import cn from "classnames";

import SearchIcon from "../icons/SearchIcon";
import './Input.scss';

export const Input = (props) => {
    const {
        maxWidth, autoFocus, refProps, value, setValue, placeholder,
        onKeyDown, padding, backgroundColor, borderRadius, border,
        zIndex, margin, onBlur, disabled, error, fontSize, onFocus,
        needFindBtn, needFindIconMobile, marginParent, color, textAlign
    } = props;

    const { activeTheme } = useSelector((state) => state.Reducer);
    const isLightTheme = activeTheme === true;
    const iconStroke = isLightTheme ? "#64748B" : "#A1A3B2";
    const iconFill = isLightTheme ? "#F1F5F9" : "white";

    return (
        <div
            className={cn("input_parent", { "theme-white": isLightTheme })}
            style={{
                ...(marginParent && {margin: marginParent})
            }}
        >
            <input
                className={cn("input_custom", {
                    disabled,
                    error,
                })}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                style={{
                    ...(maxWidth && {maxWidth}),
                    ...(padding && {padding}),
                    ...(backgroundColor
                        ? {backgroundColor}
                        : {backgroundColor: "var(--dark)"}),
                    ...(borderRadius
                        ? {borderRadius}
                        : {borderRadius: "16px"}),
                    ...(border
                        ? {border}
                        : {border: "1px solid var(--background_lighten-dark)"}),
                    ...(zIndex
                        ? {zIndex}
                        : {}),
                    ...(margin
                        ? {margin}
                        : {}),
                    ...(fontSize
                        ? {fontSize}
                        : {}),
                    ...(color
                        ? {color}
                        : {}),
                    ...(textAlign
                        ? {textAlign: "center"}
                        : {})
                }}
                ref={refProps}
                autoFocus={autoFocus || false}
                disabled={disabled}
                placeholder={placeholder || ""}
                onBlur={() => {
                    if (typeof onBlur === "function")
                        onBlur();
                }}
                onFocus={() => {
                    if (typeof onFocus === "function")
                        onFocus()
                }}
                onKeyDown={(e) => {
                    if (typeof onKeyDown === "function")
                        onKeyDown(e)
                }}
            />
            {needFindIconMobile && (
                <SearchIcon
                    className="icon_find-mobile"
                    strokeColor={iconStroke}
                    fillColor={iconFill}
                />
            )}
            {needFindBtn && (
                <>
                    <SearchIcon
                        className="icon_find"
                        strokeColor={iconStroke}
                        fillColor={iconFill}
                    />
                    <div className="btn_find">
                        <span>Найти</span>
                    </div>
                </>
            )}
        </div>
    );
};

export default Input;